import {LoadingButton} from '@mui/lab';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import {useSnackbar} from 'notistack';
import {useState} from 'react';

import API, {getMessagesFromApiError} from '../../api/axios';
import {apiBaseUrl} from '../../api/urls';
import {Company} from '../../interfaces/Company';
import {CloseSnackbarAction} from '../common/CloseSnackbarButton';
import SnackbarMessages from '../common/SnackbarMessages';

interface Props {
  item: Company;
  open: boolean;
  onDeleted?: () => void;
  onClose?: () => void;
}

export const CompanyItemDeleteDialog = ({
  item,
  open,
  onDeleted,
  onClose,
}: Props) => {
  const {enqueueSnackbar} = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const submit = async () => {
    setIsSubmitting(true);

    try {
      await API.delete(`${apiBaseUrl}/company/${item.id}`);
      const message = 'Company successfully deleted';
      enqueueSnackbar(message, {
        variant: 'success',
        action: CloseSnackbarAction,
      });
      onDeleted?.();
      onClose?.();
    } catch (error: any) {
      const messages = getMessagesFromApiError(error, "STRA_dfef5b3a");
      enqueueSnackbar(<SnackbarMessages messages={messages} />, {
        variant: 'error',
        action: CloseSnackbarAction,
      });
    }

    setIsSubmitting(false);
  };

  return (
    <Dialog open={open} onClose={() => onClose?.()}>
      <DialogTitle>Delete Company</DialogTitle>

      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete company {item.name}?
        </DialogContentText>
      </DialogContent>

      <DialogActions>
        <Button size="small" onClick={() => onClose?.()}>
          Cancel
        </Button>

        <LoadingButton
          variant="contained"
          loading={isSubmitting}
          autoFocus
          size="small"
          onClick={() => submit()}
          color="error"
        >
          Delete
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
